export default __webpack_public_path__ + "locales/sl/People.json?hash=4b561375a6d5d7144c8fab3098e5253e";